/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { Suspense } from 'react';
import _ from 'underscore';

import { Analytics } from '@trello/atlassian-analytics';
import { renderComponent } from '@trello/component-wrapper';
import {
  customFieldsId as CUSTOM_FIELDS_ID,
  e2bId,
  firstPartyPluginsOrg,
  mapPowerUpId as MAP_POWER_UP_ID,
} from '@trello/config';
import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import {
  Key,
  registerShortcut,
  Scope,
  unregisterShortcut,
} from '@trello/keybindings';
import type {
  BoardPowerUpsViewParams,
  BoardPowerUpViewParams,
} from '@trello/router';
import { useLazyComponent } from '@trello/use-lazy-component';
import {
  workspaceNavigationHiddenState,
  workspaceNavigationState,
} from '@trello/workspace-navigation';

import { setBoardLocation } from 'app/scripts/controller/setBoardLocation';
import { BUTLER_POWER_UP_ID } from 'app/scripts/data/butler-id';
import { categories } from 'app/scripts/data/directory';
import { Auth } from 'app/scripts/db/Auth';
import type { Board } from 'app/scripts/models/Board';
import { DirectoryEnabledView } from 'app/scripts/views/directory/DirectoryEnabledView';
import { DirectoryHeaderView } from 'app/scripts/views/directory/DirectoryHeaderView';
import { DirectoryHomeView } from 'app/scripts/views/directory/DirectoryHomeView';
import { DirectoryListingView } from 'app/scripts/views/directory/DirectoryListingView';
import { DirectoryPageView } from 'app/scripts/views/directory/DirectoryPageView';
import { DirectoryPluginEnableView } from 'app/scripts/views/directory/DirectoryPluginEnableView';
import { DirectorySearchView } from 'app/scripts/views/directory/DirectorySearchView';
import { DirectorySidebarView } from 'app/scripts/views/directory/DirectorySidebarView';
import { DirectorySpinnerView } from 'app/scripts/views/directory/DirectorySpinnerView';
import { pluginIOCache } from 'app/scripts/views/internal/plugins/PluginIoCache';
import type { ViewOptions } from 'app/scripts/views/internal/View';
import { View } from 'app/scripts/views/internal/View';
import {
  DiscoveryAdPowerUp,
  Source,
} from 'app/src/components/DiscoveryAdsPowerUp';
import { createSearchIndex } from 'app/src/components/PowerUpDirectory/SearchHelper';
import { LazyPowerUpsDeprecationBanner } from 'app/src/components/PowerUpsDeprecationBanner/LazyPowerUpsDeprecationBanner';
import { DirectoryLegacyPowerUps as directoryLegacyPowerUps } from './DirectoryLegacyPowerUps';

const getPageName = function (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  section: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  category: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  idPlugin: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  search: any,
) {
  let page = 'home page';

  if (search) {
    page = 'search';
  } else if (idPlugin) {
    page = 'list page';
  } else if (['enabled', 'custom', 'made-by-trello'].includes(section)) {
    page = section + ' page';
  } else if (section === 'category') {
    page = `category ${category} page`;
  }

  return `Power-Up directory ${page}`;
};

const CreateUnlimitedPupDirectoryAnnouncement = () => {
  const UnlimitedPupDirectoryAnnouncement = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "unlimited-pup-directory-announcement" */ 'app/src/components/PowerUpDirectory/UnlimitedPupDirectoryAnnouncement'
      ),
    {
      namedImport: 'UnlimitedPupDirectoryAnnouncement',
      preload: false,
    },
  );

  return (
    <ChunkLoadErrorBoundary fallback={null}>
      <Suspense fallback={null}>
        <UnlimitedPupDirectoryAnnouncement />
      </Suspense>
    </ChunkLoadErrorBoundary>
  );
};

interface DirectoryView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $contentContainer: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $directoryBody: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $directoryBodyContainer: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  activeSubview: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  boardView: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  category: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  deleteSubview: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  featuredPlugins: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headerView: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  history: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  idPlugin: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  index: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isEnabling: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isLoading: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onOrganizationChangeDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  plugins: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  search: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  section: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sidebarView: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unsubscribeFromWorkspaceNavigationHiddenState: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unsubscribeFromWorkspaceNavigationState: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  workspaceNavExpanded: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  workspaceNavHidden: any;
}

interface DirectoryViewOptions extends ViewOptions {
  section: BoardPowerUpsViewParams['section'];
  category: BoardPowerUpsViewParams['category'];
  idPlugin: BoardPowerUpViewParams['powerUpId'];
  isEnabled?: boolean;
}

class DirectoryView extends View<Board, DirectoryViewOptions> {
  static initClass() {
    // @ts-expect-error TS(2322): Type 'string' is not assignable to type '() => str... Remove this comment to see the full error message
    this.prototype.className = 'directory-wrapper';

    this.prototype.events = {
      // @ts-expect-error TS(2322): Type '{ 'click .js-directory-responsive-overlay': ... Remove this comment to see the full error message
      'click .js-directory-responsive-overlay': 'toggleNavigationMenu',
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(options: any) {
    super(options);
    this.onShortcut = this.onShortcut.bind(this);
    registerShortcut(this.onShortcut, {
      scope: Scope.PowerUpsDirectory,
      key: Key.Escape,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialize({ boardView }: any) {
    this.boardView = boardView;
    super.initialize(...arguments);

    // State
    this.featuredPlugins = [];
    this.history = [];
    this.isLoading = true;
    this.plugins = [];
    this.search = null;

    // Layout Subviews
    this.headerView = this.subview(DirectoryHeaderView, this.model, {
      directoryView: this,
    });
    this.sidebarView = this.subview(DirectorySidebarView, this.model, {
      directoryView: this,
    });

    // Routes
    this.category = this.options.category;
    this.section = this.options.section;
    this.idPlugin = this.options.idPlugin;
    this.isEnabling = this.options.isEnabling;

    // Redirect invalid routes to home.
    if (
      this.section != null &&
      !_.contains(
        ['enabled', 'category', 'custom', 'made-by-trello'],
        this.section,
      )
    ) {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      this.navigate();
    }

    if (this.category != null && !_.contains(categories, this.category)) {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      this.navigate();
    }

    this.preparePlugins();

    this.makeDebouncedMethods('onOrganizationChange');

    this.listenTo(this.model, {
      'change:idOrganization': this.onOrganizationChangeDebounced,
    });

    this.listenTo(
      this.model.boardPluginList,
      'add remove reset',
      this.frameDebounce(this.renderDeprecatedPluginsBanner),
    );

    this.workspaceNavExpanded = workspaceNavigationState.value.expanded;
    this.workspaceNavHidden = workspaceNavigationHiddenState.value.hidden;

    // listen for changes to workspae nav expanded/collapsed
    const toggleWorkspaceNavClasses = () => {
      const directoryWrapper = $('.directory-wrapper');
      this.workspaceNavExpanded = workspaceNavigationState.value.expanded;
      this.workspaceNavHidden = workspaceNavigationHiddenState.value.hidden;

      if (workspaceNavigationHiddenState.value.hidden) {
        directoryWrapper.removeClass(
          'directory-wrapper--workspace-nav-expanded',
        );
        directoryWrapper.removeClass(
          'directory-wrapper--workspace-nav-collapsed',
        );
      } else if (workspaceNavigationState.value.expanded) {
        directoryWrapper.addClass('directory-wrapper--workspace-nav-expanded');
        directoryWrapper.removeClass(
          'directory-wrapper--workspace-nav-collapsed',
        );
      } else {
        directoryWrapper.addClass('directory-wrapper--workspace-nav-collapsed');
        directoryWrapper.removeClass(
          'directory-wrapper--workspace-nav-expanded',
        );
      }
    };
    this.unsubscribeFromWorkspaceNavigationState =
      workspaceNavigationState.subscribe(toggleWorkspaceNavClasses);
    this.unsubscribeFromWorkspaceNavigationHiddenState =
      workspaceNavigationHiddenState.subscribe(toggleWorkspaceNavClasses);

    return (this.trackSearch = _.debounce(this.trackSearch, 5000, true));
  }

  remove() {
    unregisterShortcut(this.onShortcut);
    this.unsubscribeFromWorkspaceNavigationState();
    this.unsubscribeFromWorkspaceNavigationHiddenState();
    return super.remove(...arguments);
  }

  onShortcut() {
    if (!$('.js-directory-search', this.$el).is(':focus')) {
      this.boardView.closeDirectory();
      Analytics.sendPressedShortcutEvent({
        shortcutName: 'escapeShortcut',
        keyValue: 'esc',
        source: 'boardDirectoryScreen',
        containers: {
          board: { id: this.model.id },
          organization: { id: this.model.get('idOrganization') },
        },
      });
    }
  }

  onOrganizationChange() {
    this.isLoading = true;
    this.sidebarView.render();
    this.renderSubview();

    return this.model.loadPlugins().then(() => this.preparePlugins());
  }

  toggleNavigationMenu() {
    const directorySidebar = $('.js-directory-sidebar');
    const responsiveOverlay = $('.js-directory-responsive-overlay');

    if (directorySidebar.hasClass('active')) {
      directorySidebar.removeClass('active');
      return responsiveOverlay.removeClass('active');
    } else {
      directorySidebar.addClass('active');
      return responsiveOverlay.addClass('active');
    }
  }

  // ------- Data Methods -------
  // Get Power-Ups and prepare search index.
  preparePlugins() {
    let pluginPromise;
    if (this.boardView.reloadDirectoryPlugins) {
      pluginPromise = this.model.loadPlugins();
      this.boardView.reloadDirectoryPlugins = false;
    } else {
      pluginPromise = this.model.getAvailablePlugins();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return pluginPromise.then((plugins: any) => {
      this.plugins = plugins;
      if (this.model.isTemplate()) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.plugins = plugins.filter((plugin: any) => plugin.id !== e2bId);
      }

      // pass the plugin objects in as plain objects instead of ModelCache models
      this.index = createSearchIndex(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.plugins.map((plugin: any) => plugin.toJSON()),
      );

      this.isLoading = false;

      // Redirect to home if there are no custom plugins or plugin does not exist
      if (
        (this.section === 'custom' && !this.getCustomPlugins().length) ||
        (this.idPlugin && !this.getPlugin())
      ) {
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        return this.navigate();
      }

      // You shouldn't be able to see the listing of plugin that's hidden or moderated,
      // unless that plugin is also enabled on this board.
      if (this.idPlugin) {
        const plugin = this.getPlugin();
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const moderatedState = plugin.get('moderatedState');
        if (
          ['hidden', 'moderated'].includes(moderatedState) &&
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          !this.model.idPluginsEnabled().includes(plugin.id)
        ) {
          // redirect to homepage of directory
          // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
          return this.navigate();
        }

        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        if (plugin.get('idOrganizationOwner') === firstPartyPluginsOrg) {
          this.isEnabling = false;
          return this.navigate({
            section: this.section,
            idPlugin: this.idPlugin,
          });
        }
      }

      this.sidebarView.render();
      return this.renderSubview();
    });
  }

  // Return common attributes to send in tracking events
  getCommonTrackingAttributes() {
    return {
      boardPaidStatus: (() => {
        switch (false) {
          case !this.model.isEnterpriseBoard():
            return 'enterprise';
          case !this.model?.getOrganization()?.isPremium():
            return 'bc';
          case !this.model?.getOrganization()?.isStandard():
            return 'standard';
          default:
            return 'free';
        }
      })(),
      maxUserPaidStatus: !Auth.isLoggedIn()
        ? 'notLoggedIn'
        : Auth?.me()?.getMaxPaidStatus(),
    };
  }

  // Get plugin by @idPlugin
  getPlugin() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return _.find(this.plugins, (p) => p.id === this.idPlugin);
  }

  // Get plugins for the current category
  getPluginsForCategory() {
    let needle;
    return _.chain(this.plugins)
      .filter(
        (plugin) => (
          (needle = this.category),
          Array.from(plugin.get('categories')).includes(needle)
        ),
      )
      .shuffle()
      .value();
  }

  // Get custom plugins for board
  getCustomPlugins() {
    return _.chain(this.plugins)
      .filter(
        (plugin) => !plugin.get('public') && plugin.get('iframeConnectorUrl'),
      )
      .sortBy((plugin) => pluginIOCache.get(plugin).getName().toLowerCase())
      .value();
  }

  // Search logic
  getPluginsForSearch() {
    // results come back as plain objects, not ModelCache models
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.index.search(this.search).map((result: any) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return this.plugins.find((plugin: any) => plugin.id === result.id);
    });
  }

  // Get plugins with `made-by-trello` tag
  getTrelloPlugins() {
    let needle;
    return _.chain(this.plugins)
      .filter(
        (plugin) => (
          (needle = 'made-by-trello'),
          Array.from(plugin.get('tags')).includes(needle)
        ),
      )
      .sortBy((plugin) => pluginIOCache.get(plugin).getName().toLowerCase())
      .value();
  }

  getEnabledPlugins() {
    const combinedPlugins = _.flatten([
      this.model.idPluginsEnabled(),
      this.model.get('powerUps'),
    ]);
    return _.chain(combinedPlugins)
      .filter((idOrName) => {
        return (
          (!this.model.isButlerCore() || idOrName !== BUTLER_POWER_UP_ID) &&
          (!this.model.isMapCore() || idOrName !== MAP_POWER_UP_ID) &&
          idOrName !== CUSTOM_FIELDS_ID
        );
      })
      .map((idOrName) => {
        return _.find(this.plugins, (plugin) => {
          return (
            // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never[]'.
            plugin.id === idOrName ||
            _.findWhere(directoryLegacyPowerUps, {
              // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never[]'.
              id: plugin.id,
              name: idOrName,
            })
          );
        });
      })
      .compact()
      .sortBy((plugin) => pluginIOCache.get(plugin).getName().toLowerCase())
      .value();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filterUnavailablePlugins(plugins: any, options = { filterDeprecated: true }) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return plugins.filter((plugin: any) => {
      if (['moderated', 'hidden'].includes(plugin.get('moderatedState'))) {
        return false;
      }

      if (options.filterDeprecated) {
        return !plugin.get('deprecation')?.sunsetDate;
      }

      return true;
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateSearch(searchTerm: any) {
    if (searchTerm === this.search) {
      return;
    }
    this.search = searchTerm;
    if (
      !this.section &&
      !this.category &&
      !this.idPlugin &&
      !this.isEnabling &&
      searchTerm === null
    ) {
      this.history.splice(0, this.history.length);
    }
    return this.renderSubview();
  }

  trackSearch() {
    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    this.trackScreenEvent('boardDirectorySearchResultsScreen');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trackScreenEvent(name: any, attributes: any) {
    return Analytics.sendScreenEvent({
      name,
      attributes: { ...attributes, ...this.getCommonTrackingAttributes() },
      containers: {
        board: { id: this.model.id },
        organization: { id: this.model.get('idOrganization') },
      },
    });
  }

  // ------- Navigation Methods -------
  getCurrentPage() {
    return getPageName(this.section, this.category, this.idPlugin, this.search);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  navigate(param: any) {
    // Push to history if we're not traversing back or already on the same page
    if (param == null) {
      param = {};
    }
    const {
      section,
      category,
      idPlugin,
      isNavigatingBack,
      isEnabling,
      search,
    } = param;
    if (
      !isNavigatingBack &&
      !_.isEqual(
        {
          section: this.section,
          category: this.category,
          idPlugin: this.idPlugin,
          isEnabling: this.isEnabling,
        },
        { section, category, idPlugin, isEnabling },
      )
    ) {
      if (
        this.search &&
        (this.section || this.category || this.idPlugin || this.isEnabling)
      ) {
        this.history.push({
          section: this.section,
          category: this.category,
          idPlugin: this.idPlugin,
          isEnabling: this.isEnabling,
          search: null,
        });
        this.history.push({
          section: undefined,
          category: undefined,
          idPlugin: undefined,
          isEnabling: undefined,
          search: this.search,
        });
      } else {
        this.history.push({
          section: this.section,
          category: this.category,
          idPlugin: this.idPlugin,
          isEnabling: this.isEnabling,
          search: this.search,
        });
      }
    }

    const baseSlug = idPlugin ? 'power-up' : 'power-ups';

    this.section = section;
    this.category = category;
    this.idPlugin = idPlugin;
    this.isEnabling = !!isEnabling;

    const path = [];
    if (this.section != null) {
      path.push(this.section);
    }
    if (this.category != null) {
      path.push(this.category);
    }

    if (this.idPlugin != null) {
      path.push(this.idPlugin);
      if (this.isEnabling) {
        path.push('enable');
      }
    }

    setBoardLocation(this.model.id, baseSlug, path, {
      // @ts-expect-error TS(2345): Argument of type '{ replace: boolean; }' is not as... Remove this comment to see the full error message
      replace: false,
    });

    if (!(this.search && idPlugin)) {
      this.sidebarView?.clearSearch?.();
    }
    this.search = null;

    if (isNavigatingBack && search) {
      this.sidebarView.updateSearch(search);
      this.sidebarView.fillSearchField(search);
    }

    this.sidebarView.render();
    this.headerView.render();
    this.$directoryBody?.scrollTop?.(0);
    return this.renderSubview();
  }

  navigateBack() {
    if (_.isEmpty(this.history)) {
      return this.navigate({ isNavigatingBack: true });
    }

    const { section, category, idPlugin, search } = this.history.pop();
    return this.navigate({
      section,
      category,
      idPlugin,
      isNavigatingBack: true,
      search,
    });
  }

  activeEventSource() {
    // as long as its loaded, use the more-specific event source
    if (this.activeSubview) {
      return this.activeSubview.eventSource();
    } else {
      return 'boardDirectoryScreen';
    }
  }

  homeSubview() {
    return this.subview(DirectoryHomeView, this.model, {
      currentPage: this.getCurrentPage(),
      directoryView: this,
    });
  }

  enabledSubview() {
    return this.subview(DirectoryEnabledView, this.model, {
      plugins: this.plugins,
      currentPage: this.getCurrentPage(),
      directoryView: this,
    });
  }

  pluginListingSubview() {
    return this.subview(DirectoryListingView, this.model, {
      plugin: this.getPlugin(),
      currentPage: this.getCurrentPage(),
      directoryView: this,
    });
  }

  pluginEnableView() {
    return this.subview(DirectoryPluginEnableView, this.model, {
      plugin: this.getPlugin(),
      currentPage: this.getCurrentPage(),
      directoryView: this,
    });
  }

  searchSubview() {
    this.trackSearch();
    return this.subview(DirectorySearchView, this.model, {
      plugins: this.filterUnavailablePlugins(this.getPluginsForSearch(), {
        filterDeprecated: false,
      }),
      searchTerm: this.search,
      currentPage: this.getCurrentPage(),
      directoryView: this,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pageSubView(title: any, plugins: any) {
    return this.subview(DirectoryPageView, this.model, {
      title,
      plugins: this.filterUnavailablePlugins(plugins, {
        filterDeprecated: false,
      }),
      currentPage: this.getCurrentPage(),
      directoryView: this,
    });
  }

  renderDeprecatedPluginsBanner() {
    let deprecatedPluginsBanner = document.querySelector(
      '.directory-listing-deprecated-plugins-banner',
    );

    if (this.section !== 'enabled') {
      deprecatedPluginsBanner?.remove();

      return;
    }

    const deprecatedPlugins = this.getEnabledPlugins().reduce(
      // eslint-disable-next-line @typescript-eslint/no-shadow
      (deprecatedPlugins, currPlugin) => {
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        const deprecationInfo = currPlugin.get('deprecation');

        if (deprecationInfo?.sunsetDate) {
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          deprecatedPlugins.push({
            ...deprecationInfo,
            name: pluginIOCache.get(currPlugin).getName(),
          });
        }
        return deprecatedPlugins;
      },
      [],
    );

    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    if (deprecatedPlugins.length === 0) {
      deprecatedPluginsBanner?.remove();

      return;
    }

    if (!deprecatedPluginsBanner) {
      deprecatedPluginsBanner = document.createElement('div');
      deprecatedPluginsBanner.classList.add(
        'directory-listing-deprecated-plugins-banner',
      );
    }

    this.$directoryBody.prepend(deprecatedPluginsBanner);

    renderComponent(
      <LazyPowerUpsDeprecationBanner
        // @ts-expect-error TS(2322): Type 'never[] | undefined' is not assignable to ty... Remove this comment to see the full error message
        deprecatedPowerUps={deprecatedPlugins}
        showWarningIcon={false}
        centerContent
      />,
      deprecatedPluginsBanner,
    );
  }

  renderSubview() {
    // Clear out current subview
    this.$contentContainer = $('#directory-content', this.$el);
    this.$contentContainer.empty();
    if (this.activeSubview != null) {
      this.deleteSubview(this.activeSubview);
    }

    // Fancy CoffeeScript switch on nothing.
    // switch statements can also be used without a control expression,
    // turning them in to a cleaner alternative to if/else chains. :shrug:
    this.activeSubview = (() => {
      switch (false) {
        case !this.isLoading:
          return this.subview(DirectorySpinnerView, this.model, {
            section: this.section,
            idPlugin: this.idPlugin,
            isEnabling: this.isEnabling,
          });
        case !this.search:
          return this.searchSubview();
        case this.section !== 'category' || !this.category:
          return this.pageSubView(this.category, this.getPluginsForCategory());
        case this.section !== 'made-by-trello':
          return this.pageSubView(this.section, this.getTrelloPlugins());
        case this.section !== 'custom':
          return this.pageSubView(this.section, this.getCustomPlugins());
        case this.section !== 'enabled':
          return this.enabledSubview();
        case !this.idPlugin || !this.isEnabling:
          return this.pluginEnableView();
        case !this.idPlugin:
          return this.pluginListingSubview();
        default:
          return this.homeSubview();
      }
    })();

    this.renderDeprecatedPluginsBanner();

    return this.appendSubview(this.activeSubview, this.$contentContainer);
  }

  // This sets up the layout of the directory.
  renderOnce() {
    this.trackScreenEvent('boardDirectoryScreen', {
      totalEnabled: this.model.powerUpsCount(),
      allPowerUpsEnabled: this.model.idPluginsEnabled(),
    });
    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    this.appendSubview(this.headerView);

    this.$el.append('<div class="directory-body js-directory-body"></div>');
    this.$directoryBody = $('.js-directory-body', this.$el);

    if (
      !Auth.me().isDismissed('unlimited-pup-directory-announcement') &&
      Auth?.me()?.getMaxPaidStatus() === 'free'
    ) {
      this.$directoryBody.append('<div class="directory-announcement"></div>');
      renderComponent(
        <CreateUnlimitedPupDirectoryAnnouncement />,
        this.el.querySelector('.directory-announcement'),
      );
    }

    // TODO: add feature flag logic
    const isAdFlagEnabled = false;

    if (isAdFlagEnabled) {
      this.$directoryBody.append('<div class="directory-ad"></div>');
      // TODO: update the source
      renderComponent(
        <DiscoveryAdPowerUp source={Source.PowerUpDirectory} />,
        this.el.querySelector('.directory-ad'),
      );
    }

    this.$directoryBody.append('<div class="directory-body-container"></div>');
    this.$directoryBodyContainer = $('.directory-body-container', this.$el);

    this.$directoryBody.append(
      '<div class="directory-responsive-overlay js-directory-responsive-overlay"></div>',
    );

    this.appendSubview(this.sidebarView, this.$directoryBodyContainer);

    this.$directoryBodyContainer.append('<div id="directory-content"></div>');

    if (!this.workspaceNavHidden) {
      if (this.workspaceNavExpanded) {
        this.$el.addClass('directory-wrapper--workspace-nav-expanded');
      } else {
        this.$el.addClass('directory-wrapper--workspace-nav-collapsed');
      }
    }

    this.renderSubview();

    return this;
  }
}

DirectoryView.initClass();
export { DirectoryView };
